import SectionHeading from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ } from "@/data/site";

export default function FaqSection() {
  return (
    <section className="bg-white py-24 lg:py-32" data-testid="faq">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHeading eyebrow="FAQ" title="Vous avez des questions ?" />
            <p className="mt-4 text-slate-500">
              Retrouvez les réponses aux questions les plus fréquentes. Une autre question ?
              Notre équipe vous répond avec plaisir.
            </p>
          </div>

          <div className="lg:col-span-8">
            <Reveal>
              <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
                {FAQ.map((item, i) => (
                  <AccordionItem key={i} value={`faq-${i}`} className="border-b border-slate-200">
                    <AccordionTrigger
                      className="py-5 text-left font-display text-base font-semibold text-brand-blue hover:text-brand-red hover:no-underline"
                      data-testid={`faq-trigger-${i}`}
                    >
                      {item.q}
                    </AccordionTrigger>
                    <AccordionContent className="text-sm leading-relaxed text-slate-600">
                      {item.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
